import React from 'react';
import { Profile, ProfilesCard, ProfilesSection } from './../styled/Profiles.styled';
import { GrInstagram } from 'react-icons/gr';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaMobileAlt, FaFacebookMessenger } from 'react-icons/fa';
import { ImLocation, ImFacebook2 } from 'react-icons/im';
import { HiOutlineMail } from 'react-icons/hi';
import { profilesLinksData } from '../../data'
const location = "https://goo.gl/maps/xQPtwbfTeuXa1yaH7"
const Profiles = () => {
    return (
        <>
            <ProfilesSection> 
                <h4>Profiles Links</h4>
                <ProfilesCard>
                    {profilesLinksData.map((ele,index) => (
                        <Profile key={index}>
                            {ele.icon}
                            <a target="_blank" href= {ele.link}> {ele.value}</a>
                        </Profile>
                    ))}
                </ProfilesCard>
            </ProfilesSection>
        </>
    );
};

export default Profiles;